<template>
  <section class="guest-detail" style="margin-top: 16px">
    <div class="guests-page__head" style="margin: 0 0 12px">
      <div>
        <h3 class="detail-block-title" style="margin: 0">
          Diario assistenziale
        </h3>
        <p class="guests-page__subtitle">
          Attività assistenziali registrate dagli operatori (sola lettura).
        </p>
      </div>
    </div>

    <div class="billing-filters" style="margin-bottom: 14px">
      <input
        v-model="filters.from"
        type="date"
        class="search-box"
        title="Dal"
      />
      <input v-model="filters.to" type="date" class="search-box" title="Al" />
      <select v-model="filters.type" class="search-box">
        <option value="">Tutte le attività</option>
        <option v-for="d in actionDefs" :key="d.type" :value="d.type">
          {{ d.label }}
        </option>
      </select>
      <select v-model="filters.status" class="search-box">
        <option value="">Tutti gli esiti</option>
        <option v-for="(lbl, key) in statusLabels" :key="key" :value="key">
          {{ lbl }}
        </option>
      </select>
      <button
        class="villa-btn villa-btn--ghost"
        :disabled="loading"
        @click="load"
      >
        <i
          :class="
            loading ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-rotate'
          "
        ></i>
        Aggiorna
      </button>
    </div>

    <div v-if="loading" class="guests-loading">Caricamento…</div>
    <div v-else-if="!rows.length" class="guests-loading">
      Nessuna attività nel periodo selezionato.
    </div>
    <div v-else class="guests-table-wrap">
      <table class="guests-table">
        <thead>
          <tr>
            <th>Data/ora</th>
            <th>Operatore</th>
            <th>Attività</th>
            <th>Esito</th>
            <th>Valori</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in rows" :key="a.id">
            <td>{{ fmtDateTime(a.performedAt) }}</td>
            <td>{{ a.operatorName || "—" }}</td>
            <td>{{ a.actionLabel || a.actionType }}</td>
            <td>
              <span :class="['status-badge', statusClass(a.status)]">
                {{ statusLabels[a.status] || a.status }}
              </span>
            </td>
            <td>{{ value(a) || "—" }}</td>
            <td>{{ a.notes || "—" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import {
  ACTION_DEFS,
  STATUS_LABELS,
  formatActivityValue,
} from "@/utils/careActions";

export default {
  name: "GuestCareActivitiesPanel",
  props: {
    guestId: { type: [String, Number], required: true },
  },
  data() {
    return {
      rows: [],
      loading: true,
      actionDefs: ACTION_DEFS,
      statusLabels: STATUS_LABELS,
      filters: { from: "", to: "", type: "", status: "" },
    };
  },
  methods: {
    ...mapActions(["fetchGuestCareActivities"]),
    value(a) {
      return formatActivityValue(a);
    },
    statusClass(s) {
      return (
        {
          completed: "status-badge--active",
          partial: "status-badge--suspended",
          to_verify: "status-badge--suspended",
          refused: "status-badge--deceased",
          not_done: "status-badge--deceased",
          skipped: "status-badge--discharged",
        }[s] || ""
      );
    },
    fmtDateTime(d) {
      if (!d) return "—";
      const dt = new Date(d);
      if (Number.isNaN(dt.getTime())) return "—";
      const p = (n) => String(n).padStart(2, "0");
      return `${p(dt.getDate())}/${p(
        dt.getMonth() + 1
      )}/${dt.getFullYear()} ${p(dt.getHours())}:${p(dt.getMinutes())}`;
    },
    async load() {
      this.loading = true;
      try {
        this.rows = await this.fetchGuestCareActivities({
          guestId: this.guestId,
          from: this.filters.from || undefined,
          to: this.filters.to || undefined,
          type: this.filters.type || undefined,
          status: this.filters.status || undefined,
        });
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message || "Caricamento diario non riuscito."
        );
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style src="@/css/GuestsPage.css" />
<style scoped>
.billing-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.billing-filters .search-box {
  min-width: 150px;
}
</style>
